import { Controller } from "@hotwired/stimulus"

// Card #4871 (Inbox phase 1, part C). Mobile swipe gestures on one Inbox
// row (ADR-0183 note 4a): swipe right marks the row Done directly (a
// single, reversible action -- a new activity reopens it); swipe left
// opens the row's overflow menu, since Snooze needs a preset or a date
// picked rather than a guess. The same menu is the accessibility fallback
// for anyone who doesn't swipe (ADR-0183 note 4a's "same two actions... in
// an overflow menu"), reached by tapping the kebab button normally.
//
// Mirrors field_activity_calendar_controller.js's swipeStart/swipeEnd shape:
// touchstart/touchend only (no live drag feedback), a horizontal-vs-vertical
// ratio check so page scroll is unaffected, no preventDefault.
export default class extends Controller {
  static targets = ["doneLink", "overflowButton"]

  static SWIPE_MIN_PX = 60

  swipeStart(event) {
    const touch = event.changedTouches[0]
    this.swipeOrigin = { x: touch.clientX, y: touch.clientY }
  }

  swipeEnd(event) {
    if (!this.swipeOrigin) return

    const touch = event.changedTouches[0]
    const dx = touch.clientX - this.swipeOrigin.x
    const dy = touch.clientY - this.swipeOrigin.y
    this.swipeOrigin = null

    const horizontal = Math.abs(dx) >= this.constructor.SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy) * 1.5
    if (!horizontal) return

    // Swipe right -> Done. Swipe left -> open the overflow menu (Snooze lives there).
    if (dx > 0 && this.hasDoneLinkTarget) this.doneLinkTarget.click()
    if (dx < 0 && this.hasOverflowButtonTarget) this.overflowButtonTarget.click()
  }
}
